import { WizardLightLayout } from 'src/v2/features/layout/wizard/WizardLightLayout';

export const LayoutLight: React.FC = ({ children }): JSX.Element => (
  <WizardLightLayout>
    <div className="l-container">{children}</div>
  </WizardLightLayout>
);
